<template>
    <div class="layers-container">
        <!--  -->
        <div v-if="isLayerMosaicsVisible" class="button-layer-main-container">
            <div @click="mosaicsGlobal = !mosaicsGlobal" class="button-layer-main" v-bind:class="{ 'button-layer-main-selected': mosaicsGlobal }">
                <div class="button-light" v-bind:class="{ 'button-light-on': mosaicsGlobal }"></div>
                Mosaico global
            </div>
            <div @click="mosaicsCampaigns = !mosaicsCampaigns"  class="button-layer-main" v-bind:class="{ 'button-layer-main-selected': mosaicsCampaigns }">
                <div class="button-light" v-bind:class="{ 'button-light-on': mosaicsCampaigns }"></div>
                Por campaña 
            </div>
        </div>
        <div v-if="isLayerBathymetryVisible" class="button-layer-main-container">
            <div @click="bathymetryGlobal = !bathymetryGlobal" class="button-layer-main" v-bind:class="{ 'button-layer-main-selected': bathymetryGlobal }">
                <div class="button-light" v-bind:class="{ 'button-light-on': bathymetryGlobal }"></div>
                Batimetría global
            </div>
            <div @click="bathymetryCampaigns = !bathymetryCampaigns"  class="button-layer-main" v-bind:class="{ 'button-layer-main-selected': bathymetryCampaigns }">
                <div class="button-light" v-bind:class="{ 'button-light-on': bathymetryCampaigns }"></div>
                Por campaña 
            </div>
        </div>
        <div v-if="isLayerSonarsVisible" class="button-layer-main-container">
            <div @click="sonarsGlobal = !sonarsGlobal" class="button-layer-main" v-bind:class="{ 'button-layer-main-selected': sonarsGlobal }">
                <div class="button-light" v-bind:class="{ 'button-light-on': sonarsGlobal }"></div>
                Sónar global
            </div>
            <div @click="sonarsCampaigns = !sonarsCampaigns"  class="button-layer-main" v-bind:class="{ 'button-layer-main-selected': sonarsCampaigns }">
                <div class="button-light" v-bind:class="{ 'button-light-on': sonarsCampaigns }"></div>
                Por campaña 
            </div>
        </div>
    </div>
</template>

<script>
  // Vuex
  import { mapGetters } from 'vuex'
  import {getData} from './../../services/api'
  

  export default {
    name: 'panelLayers',
    data: function () {
        return {
            hover_param: null,
        }
    },
    computed: {
        ...mapGetters(['isLayerMosaicsVisible','isLayerBathymetryVisible','isLayerSonarsVisible']),
        /////////////////////////////// mosaics//////////////////////
        mosaicsCampaignsList: {
            set (campaignsList) { this.$store.dispatch('changeMosaicsCampaignsList', {mosaicsCampaignsList: campaignsList}); },
            get () { return this.$store.state.mapLayers.layerMosaics.mosaicsCampaignsList }
        },
        mosaicsCampaignsListFiltered: {
            set (campaignsList) { this.$store.dispatch('changeMosaicsCampaignsListFiltered', {mosaicsCampaignsListFiltered: campaignsList}); },
            get () { return this.$store.state.mapLayers.layerMosaics.mosaicsCampaignsListFiltered }
        },
        mosaicsGlobal: {
          set () { this.$store.dispatch('changeMosaicsGlobalOrCampaigns', {globalOrCampaigns: 'global'}); },
          get () { return this.$store.state.mapLayers.layerMosaics.mosaicsGlobal }
        },
        mosaicsCampaigns: {
            set () { this.$store.dispatch('changeMosaicsGlobalOrCampaigns', {globalOrCampaigns: 'campaigns'}); },
            get () { return this.$store.state.mapLayers.layerMosaics.mosaicsCampaigns }
        },
        ///////////////////////////////bathymetry//////////////////////
        bathymetryGlobal: {
          set () { this.$store.dispatch('changeBathymetryGlobalOrCampaigns', {globalOrCampaigns: 'global'}); },
          get () { return this.$store.state.mapLayers.layerBathymetry.bathymetryGlobal }
        },
        bathymetryCampaigns: {
            set () { this.$store.dispatch('changeBathymetryGlobalOrCampaigns', {globalOrCampaigns: 'campaigns'}); },
            get () { return this.$store.state.mapLayers.layerBathymetry.bathymetryCampaigns }
        },
        bathymetryGlobal: {
          set () { this.$store.dispatch('changeBathymetryGlobalOrCampaigns', {globalOrCampaigns: 'global'}); },
          get () { return this.$store.state.mapLayers.layerBathymetry.bathymetryGlobal }
        },
        bathymetryCampaigns: {
            set () { this.$store.dispatch('changeBathymetryGlobalOrCampaigns', {globalOrCampaigns: 'campaigns'}); },
            get () { return this.$store.state.mapLayers.layerBathymetry.bathymetryCampaigns }
        },
        ////////////////////////////////Sonars////////////////////////
        sonarsCampaignsList: {
          set (campaignsList) { this.$store.dispatch('changeSonarsCampaignsList', {sonarsCampaignsList: campaignsList}); },
          get () { return this.$store.state.mapLayers.layerSonars.sonarsCampaignsList }
        },
        sonarsCampaignsListFiltered: {
            set (campaignsList) { this.$store.dispatch('changeSonarsCampaignsListFiltered', {sonarsCampaignsListFiltered: campaignsList}); },
            get () { return this.$store.state.mapLayers.layerSonars.sonarsCampaignsListFiltered }
        },
        sonarsGlobal: {
          set () { this.$store.dispatch('changeSonarsGlobalOrCampaigns', {globalOrCampaigns: 'global'}); },
          get () { return this.$store.state.mapLayers.layerSonars.sonarsGlobal }
        },
        sonarsCampaigns: {
            set () { this.$store.dispatch('changeSonarsGlobalOrCampaigns', {globalOrCampaigns: 'campaigns'}); },
            get () { return this.$store.state.mapLayers.layerSonars.sonarsCampaigns }
        },
        
    },

    componets:{
        
    },
    beforeMount () {
       // this.getMosaicData()
    },

    mounted () {
       
        this.getMosaicData() 
        this.getBathymetryData() 
        this.getSonarData() 
    },
    methods: {
        getMosaicData: function () {
          var url = 'mmdata/mosaic-campaigns/'
          getData(url).then(res=> {
              this.mosaicsCampaignsList = res.data.mosaicCampaigns
              this.mosaicsCampaignsListFiltered = res.data.mosaicCampaigns
          })
        },
        getBathymetryData: function () {
          var url = 'mmdata/bathymetry-campaigns/'
          getData(url).then(res=> {
              this.bathymetryCampaignsList = res.data.bathymetryCampaigns
              this.bathymetryCampaignsListFiltered = res.data.bathymetryCampaigns
          })
        },
        getSonarData: function () {
          var url = 'mmdata/sonar-campaigns/'
          getData(url).then(res=> {
              this.sonarsCampaignsList = res.data.sonarCampaigns
              this.sonarsCampaignsListFiltered = res.data.sonarCampaigns
          })
      },
    }
  }
</script>

<style scoped>
    .layers-container {
        display: flex;
        flex-direction: row;
    }
    .button-layer-main-container {
        width: 100%;
        display: flex; 
        flex-direction: row; 
        justify-content: space-around;
        margin-top: 12px;
        margin-bottom: 16px;
    }


    /* STATIONS OR DENSITY BUTTONS */   
    .button-layer-main {
        /* background-color: #f4fafe; */
        padding: 12px;
        border-radius: 50px;
        width: 45%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #C6DDE2FF;
        font-size: 0.9rem;
        cursor: pointer;
        /* box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.3); */
        /* background: linear-gradient(180deg, #f4fafeFF 0%, #f4fafeFF 80%); */
        /* background: linear-gradient(180deg, #C6DDE277 0%, #ffffff 30%); */
        box-shadow: 4px 4px 5px #C6DDE2, 
            -5px -5px 6px #ffffff;
    }
    .button-layer-main-selected {
        color: #447998;
        box-shadow: 1px 1px 3px #C6DDE2, 
            -5px -5px 6px #ffffff;
    }
    .button-light {
        margin-right: 12px;
        border-radius: 50px;
        width: 7px;
        height: 7px;
        background-color: #C6DDE277;
    }
    .button-light-on {
        border-radius: 50px;
        background-color:#1CBBB4;
        /* box-shadow: 0px 0px 5px #1CBBB4 */
    }
    .button-layer-main:hover {
        color:#1CBBB4;
    }


    /* **********   ANIMATIONS   ************ */
    .button-layer-main,.button-light,.button-param,.param {
        -webkit-transition: .25s ease-in-out;
        -moz-transition: .25s ease-in-out;
        -o-transition: .25s ease-in-out;
        transition: .25s ease-in-out;
    }


</style>



// WEBPACK FOOTER //
// src/components/map/panelLayers.vue